// NOTE: Dependencies: jQuery
// NOTE: This module MUST run first

(function($) {
	$.fn.lmGlobal = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			noJs: 'no-js',
			js: 'js',
			$body: $('#body'),
			bodyRestrain: 'body-restrain',
			bodyAnimating: 'body--animating',
			siteOverlay: 'site-overlay',
			siteOverlayNoBg: 'site-overlay--no-bg',
			$siteOverlayItem: $('.site-overlay__item'),
			$header: $('#header'),
			$jumplinks: $('.jumplinks'),
			jumplinksFixed: 'jumplinks--fixed',
			jumplinksOffset: 'jumplinks--offset',
			$secondaryNav: $('.secondary-nav'),
			secondaryNavFixed: 'secondary-nav--fixed',
			secondaryNavOffset: 'secondary-nav--offset',
			$section: $('.section'),
			sectionActive: 'section--active',
			$collection: $('.collection'),
			collectionActive: 'collection--active',
			$collectionToggle: $('.collection-toggle'),
			collectionToggleActive: 'collection-toggle--active',
			$collectionAccordion: $('.collection--accordion'),
			$collectionToggleButton: $('.collection-toggle__button'),
			collectionToggleButtonActive: 'collection-toggle__button--active',
			active: 'header--active',
			$primaryNav: $('.primary-nav'),
			primaryNavDark: 'primary-nav--dark',
			primaryNavActive: 'primary-nav--active',
			$primaryNavList: $('.primary-nav__list'),
			$primaryNavItemActive: $('.primary-nav__item--active'),
			primaryNavItemActive: 'primary-nav__list--active',
			$primaryNavInPage: $('.primary-nav-in-page'),
			primaryNavInPageDark: 'primary-nav-in-page--dark',
			primaryNavInPageActive: 'primary-nav-in-page--active',
			$primaryNavInPageList: $('.primary-nav-in-page__list'),
			$primaryNavInPageItemActive: $('.primary-nav-in-page__item--active'),
			primaryNavInPageItemActive: 'primary-nav-in-page__list--active',
			$sectionNav: $('.section-nav'),
			$sectionNavItem: $('.section-nav__item'),
			sectionNavItemActive: 'section-nav__item--active',
			$sectionNavItemAlwaysActive: $('.section-nav__item.section-nav__item--always-active'),
			sectionNavItemAlwaysActive: 'hide',
			sectionNavItemDark: 'section-nav__item--dark',
			$sectionNavButton: $('.section-nav__button'),
			$sectionNavLink: $('button.section-nav__link'),
			sectionNavActive: 'section-nav--active',
			$sectionNavInPage: $('.section-nav-in-page'),
			$sectionNavInPageItem: $('.section-nav-in-page__item'),
			sectionNavInPageItemActive: 'section-nav-in-page__item--active',
			$sectionNavInPageItemAlwaysActive: $('.section-nav-in-page__item.section-nav-in-page__item--always-active'),
			sectionNavInPageItemAlwaysActive: 'hide',
			sectionNavInPageItemDark: 'section-nav-in-page__item--dark',
			$sectionNavInPageButton: $('.section-nav-in-page__button'),
			$sectionNavInPageLink: $('button.section-nav-in-page__link'),
			sectionNavInPageActive: 'section-nav-in-page--active',
			$searchBar: $('.search-bar'),
			$searchBarContainer: $('.search-bar__container'),
			searchBarLoader: 'loader',
			$searchBarButton: $('.search-bar-button'),
			searchBarButtonActive: 'search-bar-button--active',
			searchBarActive: 'search-bar--active',
			$languageSelectorToggle: $('.language-selector--mega-dropdown .language-selector__toggle'),
			languageSelectorToggleActive: 'language-selector__toggle--active',
			$languageSelectorDropdown: $('.language-selector__dropdown'),
			languageSelectorDropdownActive: 'language-selector__dropdown--active',
			$regionList: $('.region-list'),
			regionListItem: '.region-list__item',
			regionListItemActive: 'region-list__item--active',
			countryListActive: 'country-list--active',
			$predictiveSearch: $('.predictive-search'),
			predictiveSearchClass: 'predictive-search--active',
			skrollable: $('.skrollable').length,
			$imagePopup: $('.image-popup'),
			feedback: '.feedback',
			$feedbackInput: $('.feedback__input'),
			feedbackInput: '.feedback__input',
			feedbackResponseNegative: '.feedback__response--negative',
			feedbackResponsePositive: '.feedback__response--positive',
			$window: $(window),
			mobileDetect: new MobileDetect(window.navigator.userAgent)
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);

			if (!$('.content-tabbed').length) {
				$.each(settings.$collectionAccordion, function(){
					var id = $(this).attr('id');

					if(!$('*[data-collection-id="#' + id + '"]').hasClass('collection-toggle--active')) {
						settings.$collectionAccordion.css('display','none');
					}
				});
			}
		};

		// Toggle Nav Active Classes
		methods.toggleNav = function() {
			// Deactivate the search bar if it's open
			if (settings.$searchBar.hasClass(settings.searchBarActive)) {
				settings.$searchBar.removeClass(settings.searchBarActive);
			}
			settings.$sectionNav.toggleClass(settings.sectionNavActive);
			settings.$body.toggleClass(settings.bodyRestrain);
		};

		// Toggle Nav Active Classes
		methods.toggleSearch = function() {
			// Close language selector
			settings.$body.removeClass(settings.siteOverlay);
			settings.$languageSelectorToggle.removeClass(settings.languageSelectorToggleActive);
			settings.$languageSelectorDropdown.removeClass(settings.languageSelectorDropdownActive);
			methods.removeLanguageSelectorContent();

			// Deactivate the section nav if it's open
			if (settings.$sectionNav.hasClass(settings.sectionNavActive)) {
				settings.$sectionNav.removeClass(settings.sectionNavActive);
			}
			settings.$searchBar.toggleClass(settings.searchBarActive);
      settings.$searchBarButton.toggleClass(settings.searchBarButtonActive);
      $("#searchBar").focus();
		};

		// Toggle Language Selector Dropdown
		methods.toggleLanguageSelectorMegaDropdown = function() {
			settings.$searchBar.removeClass(settings.searchBarActive);

			// Toggle changed to if, because of the multiple different elements in the header
			if (!settings.$body.hasClass(settings.siteOverlay)) {
				settings.$body.addClass(settings.siteOverlay);
			} else if (settings.$predictiveSearch.hasClass(settings.predictiveSearchClass)) {

				// Removing class so shows teal overlay
				settings.$body.removeClass(settings.siteOverlayNoBg);

				// Remove predictive search loader
				settings.$searchBarContainer.removeClass(settings.searchBarLoader);

				// Removing predictive search panel
				settings.$predictiveSearch.removeClass(settings.predictiveSearchClass);
			} else {
				settings.$body.removeClass(settings.siteOverlay);
			}

			settings.$languageSelectorToggle.toggleClass(settings.languageSelectorToggleActive);
			settings.$languageSelectorDropdown.toggleClass(settings.languageSelectorDropdownActive);

			if (settings.$languageSelectorDropdown.hasClass(settings.languageSelectorDropdownActive)) {
				methods.loadLanguageSelectorContent();
			} else {
				methods.removeLanguageSelectorContent();
			}
		};

		// Toggle Nav Active Classes
		methods.toggleSection = function($this) {
			var $activePrimaryNavList = $('#' + $this.attr('data-section')),
				$sectionNavItem = $this.parents('.section-nav__item'),
				primaryNavActiveDelay = 0;

			// If primary nav is active
			if (settings.$primaryNav.hasClass(settings.primaryNavActive)) {
				// Set delay to match animation speed
				primaryNavActiveDelay = 250;
			}
			// If Section Nav is already active
			if ($sectionNavItem.hasClass(settings.sectionNavItemActive)) {
				// If the mobile section nav is open
				if (!settings.$sectionNav.hasClass(settings.sectionNavActive)) {
					settings.$primaryNav.removeClass(settings.primaryNavActive);
					$activePrimaryNavList.removeClass(settings.primaryNavItemActive);
					settings.$primaryNav.removeClass(settings.primaryNavDark);
					$sectionNavItem.removeClass(settings.sectionNavItemDark);
					settings.$sectionNavItemAlwaysActive.removeClass(settings.sectionNavItemAlwaysActive);
				}
				$sectionNavItem.removeClass(settings.sectionNavItemActive);
			} else {
				// Reset Primary nav list active class
				settings.$primaryNavList.removeClass(settings.primaryNavItemActive);
				// Reset Section nav list active class
				settings.$sectionNavItem.removeClass(settings.sectionNavItemActive);
				// hide the primary nav if the section nav dropdown is NOT active
				if (!settings.$sectionNav.hasClass(settings.sectionNavActive)) {
					settings.$primaryNav.removeClass(settings.primaryNavActive);
					$activePrimaryNavList.removeClass(settings.primaryNavItemActive);
					settings.$primaryNav.removeClass(settings.primaryNavDark);
					$sectionNavItem.removeClass(settings.sectionNavItemDark);
					settings.$sectionNavItemAlwaysActive.removeClass(settings.sectionNavItemAlwaysActive);
				}
				// Set Active states
				setTimeout(function() {
					settings.$primaryNav.removeClass(settings.primaryNavDark);
					if ($activePrimaryNavList.attr('data-style') == 'dark') {
						settings.$primaryNav.addClass(settings.primaryNavDark);
						$sectionNavItem.addClass(settings.sectionNavItemDark);
					}
					settings.$primaryNav.addClass(settings.primaryNavActive);
					$sectionNavItem.addClass(settings.sectionNavItemActive);
					settings.$sectionNavItemAlwaysActive.addClass(settings.sectionNavItemAlwaysActive);
					$activePrimaryNavList.addClass(settings.primaryNavItemActive);
				}, primaryNavActiveDelay);
			}
		};

		// Toggle Nav In Page Active Classes
		methods.toggleSectionInPage = function($this) {
			var $activePrimaryNavInPageList = $('#' + $this.attr('data-section')),
				$sectionNavInPageItem = $this.parents('.section-nav-in-page__item');

			// If Section Nav is already active
			if ($sectionNavInPageItem.hasClass(settings.sectionNavInPageItemActive)) {
				// If the mobile section nav is open
				if (!settings.$sectionNavInPage.hasClass(settings.sectionNavInPageActive)) {
					settings.$primaryNavInPage.removeClass(settings.primaryNavInPageActive);
					$activePrimaryNavInPageList.removeClass(settings.primaryNavInPageItemActive);
					settings.$primaryNavInPage.removeClass(settings.primaryNavInPageDark);
					$sectionNavInPageItem.removeClass(settings.sectionNavInPageItemDark);
					settings.$sectionNavInPageItemAlwaysActive.removeClass(settings.sectionNavInPageItemAlwaysActive);
				}
				$sectionNavInPageItem.removeClass(settings.sectionNavInPageItemActive);
			} else {
				// Reset Primary nav list active class
				settings.$primaryNavInPageList.removeClass(settings.primaryNavInPageItemActive);
				// Reset Section nav list active class
				settings.$sectionNavInPageItem.removeClass(settings.sectionNavInPageItemActive);
				// hide the primary nav if the section nav dropdown is NOT active
				if (!settings.$sectionNavInPage.hasClass(settings.sectionNavInPageActive)) {
					settings.$primaryNavInPage.removeClass(settings.primaryNavInPageActive);
					$activePrimaryNavInPageList.removeClass(settings.primaryNavInPageItemActive);
					settings.$primaryNavInPage.removeClass(settings.primaryNavInPageDark);
					$sectionNavInPageItem.removeClass(settings.sectionNavInPageItemDark);
					settings.$sectionNavInPageItemAlwaysActive.removeClass(settings.sectionNavInPageItemAlwaysActive);
				}

				// Set Active states
				settings.$primaryNavInPage.removeClass(settings.primaryNavInPageDark);
				if ($activePrimaryNavInPageList.attr('data-style') == 'dark') {
					settings.$primaryNavInPage.addClass(settings.primaryNavInPageDark);
					$sectionNavInPageItem.addClass(settings.sectionNavInPageItemDark);
				}
				settings.$primaryNavInPage.addClass(settings.primaryNavInPageActive);
				$sectionNavInPageItem.addClass(settings.sectionNavInPageItemActive);
				settings.$sectionNavInPageItemAlwaysActive.addClass(settings.sectionNavInPageItemAlwaysActive);
				$activePrimaryNavInPageList.addClass(settings.primaryNavInPageItemActive);
			}
		};

		// Toggle Nav Active Classes
		methods.toggleRegionList = function($this) {
			var $countryList = $($this.attr('data-country-list'));
			settings.$regionListButton.removeClass(settings.regionListButtonActive);
			settings.$regionListItem.removeClass(settings.regionListItemActive);
			$this.parents(settings.regionListItem).addClass(settings.regionListItemActive);

			settings.$countryList.removeClass(settings.countryListActive);
			$countryList.addClass(settings.countryListActive);
		};

		// Toggle Section
		methods.toggleCollectionAccordion = function($this) {
			var $collectionToggle = $this.parents('.collection-toggle'),
				$collection = $($collectionToggle.data('collection-id'));

			if ($collection.hasClass(settings.collectionActive)) {
				$collectionToggle.removeClass(settings.collectionToggleActive);
				$collection.slideUp(250, function() {
					$collection.removeClass(settings.collectionActive);
				});
			} else {
				$collectionToggle.addClass(settings.collectionToggleActive);
				$collection.slideDown(250, function() {
					$collection.addClass(settings.collectionActive);
				});
			}
		};

		// Feedback submit
		methods.feedbackSubmit = function($this) {
			var $feedbackForm = $this.parents(settings.feedback),
				$feedbackInput = $feedbackForm.find(settings.feedbackInput),
				feedbackSubmitValue = $this.val();

			if(feedbackSubmitValue == 'yes'){
				$feedbackInput.prop('disabled', true);
				$feedbackForm.find(settings.feedbackResponsePositive).slideDown(250);
			}
			else {
				$feedbackInput.prop('disabled', true);
				$feedbackForm.find(settings.feedbackResponseNegative).slideDown(250);
			}
		};

		// Bind events
		methods.events = function() {

			// Adding quick events for BED as requested from them.
			$("#searchBarTarget").on('change', function () {
				var searchTarget = $("#searchBarTarget").val();
				$('#mainSearchBar').get(0).setAttribute('action', searchTarget);
			});

			$("#resetFormToggle").on('click', function() {
				$("#resetPassword").show();
			});

			// Resize

			$(window).on('resize', function() {
				var resizeId;
				clearTimeout(resizeId);

				resizeId = setTimeout((function() {

					// Leaving commented for now as not working properly but need to do.
					//methods.skrollableInit();
				}), 250);
			});

			// Mobile Menu button click toggles the class
			settings.$sectionNavButton.off('click.lmGlobal').on('click.lmGlobal', function(event) {
				event.preventDefault();
				methods.toggleNav();
			});

			// Mobile Search button click toggles the class
			settings.$searchBarButton.off('click.lmGlobal').on('click.lmGlobal', function(event) {
				event.preventDefault();
				methods.toggleSearch();
			});

			// Mobile Search button click toggles the class
			settings.$collectionToggleButton.off('click.lmGlobal').on('click.lmGlobal', function(event) {
				event.preventDefault();
				var $this = $(this);
				methods.toggleCollectionAccordion($this);

				// Need to make this more intuitive eventually so doesn't get called on every click
				if($('div[data-slick]').length && $('div[data-slick]').hasClass('slick-initialized')) {
					$('div[data-slick]').slick('refresh');
				}
			});

			// On click of product feature detail
			settings.$feedbackInput.off('change.lmGlobal').on('change.lmGlobal', function(event) {
				event.preventDefault();
				var $this = $(this);
				methods.feedbackSubmit($this);
			});

			// Section nav toggle
			settings.$sectionNavLink.off('click.lmGlobal').on('click.lmGlobal', function(event) {
				event.preventDefault();
				var $this = $(this);
				methods.toggleSection($this);

				// Close predictive search
				if (settings.$predictiveSearch.hasClass(settings.predictiveSearchClass)) {
					settings.$predictiveSearch.removeClass(settings.predictiveSearchClass);

					// Remove predictive search loader
					settings.$searchBarContainer.removeClass(settings.searchBarLoader);
				}

				// Close language selector
				settings.$languageSelectorToggle.removeClass(settings.languageSelectorToggleActive);
				settings.$languageSelectorDropdown.removeClass(settings.languageSelectorDropdownActive);
				methods.removeLanguageSelectorContent();
				settings.$body.removeClass(settings.siteOverlay + ' site-overlay--no-bg');
			});

			// Section nav in page toggle
			settings.$sectionNavInPageLink.off('click.lmGlobal').on('click.lmGlobal', function(event) {
				event.preventDefault();
				var $this = $(this);
				methods.toggleSectionInPage($this);
			});

			// Language selector toggle
			settings.$languageSelectorToggle.off('click.lmGlobal').on('click.lmGlobal', function(event) {
				event.preventDefault();
				var $this = $(this);
				methods.toggleLanguageSelectorMegaDropdown($this);
			});



			// Closing overlay
			settings.$siteOverlayItem.on('click.lmGlobal', function(event) {
				event.preventDefault();
				settings.$body.removeClass(settings.siteOverlay + ' site-overlay--no-bg');

				// Remove predictive search loader
				settings.$searchBarContainer.removeClass(settings.searchBarLoader);

				// Removing predictive search panel
				settings.$predictiveSearch.removeClass(settings.predictiveSearchClass);

				// Removing Language Selector
				settings.$languageSelectorToggle.removeClass(settings.languageSelectorToggleActive);
				settings.$languageSelectorDropdown.removeClass(settings.languageSelectorDropdownActive);
				methods.removeLanguageSelectorContent();

				// TODO. Add rest of panels.
			});
		};

		methods.loadLanguageSelectorContent = function() {
			var ajaxUrl = settings.$languageSelectorDropdown.data('ajax-url');

			$.ajax({
				type: 'GET',
				dataType: 'html',
				url: ajaxUrl,
				success: function(data) {

					// Set html
					settings.$languageSelectorDropdown.html(data);

					$('.content-tabbed').contentTabs();

					$('.language-selector__dropdown .content-tabbed__item').on('click.contentTabs', function(event) {

						var $this = $(event.currentTarget),
							$languageSelector = $('.language-selector__dropdown');

						// Not done toggle just in case client wants tabs open by default
						// Also adding event here rather than in content tabs to keep content tabs module self contained
						if ($this.parent().hasClass('content-tabbed__wrapper--active')) {
							$languageSelector.addClass('language-selector__dropdown--mobile-height');
						} else {
							$languageSelector.removeClass('language-selector__dropdown--mobile-height');
						}
					});
				}
			});
		};

		methods.removeLanguageSelectorContent = function() {
			settings.$languageSelectorDropdown.html('');
		};

		methods.skrollableInit = function() {

			// If a skrollable element exists and useragent isn't mobile
			if (settings.mobileDetect.mobile() == null && settings.skrollable && settings.$window.width() > 768) {
				// Initalise Skrollr
				settings.skrollr = skrollr.init({
					forceHeight: false,
					mobileDeceleration: 0.004,
					smoothScrolling: false,
				});
				setTimeout(function() {
					// TODO: Find a better solution than a time out
					settings.skrollr.refresh();
				}, 3000);

			}
		}

		// On load function.
		methods.initContext = function() {

			methods.setCurrentSettings();
			// Remove the no-js class from the body and add the js class.
			$context.addClass(settings.js).removeClass(settings.noJs);

			// Scroll primary nav to active item position
			if (typeof settings.$primaryNavItemActive !== 'undefined' && settings.$primaryNavItemActive.length > 0) {
				var primaryNavItemActivePosition = settings.$primaryNavItemActive.position();
				settings.$primaryNavList.animate({
					scrollLeft: primaryNavItemActivePosition.left
				}, 1000, 'swing');
			}

			settings.$imagePopup.magnificPopup({
				disableOn: 700,
				type: 'image',
				mainClass: 'mfp-fade',
				removalDelay: 0,
				preloader: false,
				fixedContentPos: false,
			});

			if (settings.mobileDetect.mobile() && !settings.mobileDetect.tablet()) {
				$context.addClass('is-mobile');
			} else if (settings.mobileDetect.ua.indexOf('Trident') != -1) {
				$context.addClass('is-IE is-desktop');
			} else if (settings.mobileDetect.ua.indexOf('Edge') != -1) {
				$context.addClass('is-Edge is-desktop');
			} else if (settings.mobileDetect.tablet()) {
				$context.addClass('is-tablet');
			} else {
				$context.addClass('is-desktop');
			}

			// SVG IE fix

			if ($context.hasClass('is-IE')) {
				$('svg').each(function(e){
					$(this).wrap( "<div class='svgfix'></div>" );
				});
			}

			// Init skrollable
			methods.skrollableInit();

			// Initalise head room
			settings.$header.headroom({

				// Offset for header height
				offset: settings.$header.outerHeight(),
				tolerance: {
					up: 15,
					down: 15
				},
				classes: {
					// when element is initialised
					initial: 'site-header--initialised',
					// when scrolling up
					pinned: 'site-header--pinned',
					// when scrolling down
					unpinned: 'site-header--unpinned',
					// when above offset
					top: 'site-header--top',
					// when below offset
					notTop: 'site-header--not-top',
					// when at bottom of scoll area
					bottom: 'site-header--bottom',
					// when not at bottom of scroll area
					notBottom: 'site-header--not-bottom'
				},
				onPin: function() {
					if (settings.$body.hasClass(settings.bodyAnimating)) {
						// If the nav overlay is open, disable headroom
						if (settings.$sectionNav.hasClass(settings.sectionNavActive)) {
							this.elem.classList.remove(this.classes.unpinned);
							this.elem.classList.add(this.classes.pinned);
						} else {
							this.elem.classList.add(this.classes.unpinned);
							this.elem.classList.remove(this.classes.pinned);
						}
					} else {
						if (settings.$jumplinks.hasClass(settings.jumplinksFixed)) {
							settings.$jumplinks.addClass(settings.jumplinksOffset);
						}
						if (settings.$secondaryNav.hasClass(settings.secondaryNavFixed)) {
							settings.$secondaryNav.addClass(settings.secondaryNavOffset);
						}
					}

				},
				onUnpin: function() {
					if (settings.$body.hasClass(settings.bodyAnimating)) {
						// If the nav overlay is open, disable headroom
						if (settings.$sectionNav.hasClass(settings.sectionNavActive)) {
							this.elem.classList.remove(this.classes.unpinned);
							this.elem.classList.add(this.classes.pinned);
						} else {
							this.elem.classList.add(this.classes.unpinned);
							this.elem.classList.remove(this.classes.pinned);
						}
					}
					if (settings.$jumplinks.hasClass(settings.jumplinksFixed)) {
						settings.$jumplinks.removeClass(settings.jumplinksOffset);
					}
					if (settings.$secondaryNav.hasClass(settings.secondaryNavFixed)) {
						settings.$secondaryNav.removeClass(settings.secondaryNavOffset);
					}

					if (settings.$predictiveSearch.hasClass(settings.predictiveSearchClass)) {
						settings.$predictiveSearch.removeClass(settings.predictiveSearchClass);
						settings.$body.removeClass(settings.siteOverlay + ' site-overlay--no-bg');

						// Remove predictive search loader
						settings.$searchBarContainer.removeClass(settings.searchBarLoader);
					}
				}
			});
			// End headroom init
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	// Attach and run code
	$('html').lmGlobal();

}(jQuery));
